<template>
  <div class="reset-password">
    <p class="title">原密码强度弱，请修改密码！</p>
    <el-form
      :model="editForm"
      :rules="rules"
      ref="editForm"
      style="width: 500px; margin-left: -150px"
      label-width="100px"
    >
      <el-form-item prop="oldPassword" label="现密码">
        <el-input
          type="password"
          v-model="editForm.oldPassword"
          placeholder="请输入现密码"
          auto-complete="off"
        ></el-input>
      </el-form-item>
      <el-form-item prop="newPassword" label="新密码">
        <el-input
          type="password"
          v-model="editForm.newPassword"
          placeholder="请输入新密码"
          auto-complete="off"
        ></el-input>
      </el-form-item>
      <el-form-item prop="newPassword2" label="确认新密码">
        <el-input
          type="password"
          v-model="editForm.newPassword2"
          placeholder="请再次输入新密码"
          auto-complete="off"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" :loading="saveing" @click="handleSave"
        >保 存</el-button
      >
    </div>
  </div>
</template>

<script>
import VueCookie from 'vue-cookies'
import JSEncrypt from 'jsencrypt'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const validPassword = (rule, value, callback) => {
      if (value !== '' && this.editForm.newPassword2 !== '') {
        this.$refs.editForm.validateField('newPassword2')
      }
      callback()
    }
    const validPassword2 = (rule, value, callback) => {
      if (value !== '' && value !== this.editForm.newPassword) {
        callback(new Error('两次输入密码不一致！'))
      } else {
        callback()
      }
    }
    return {
      saveing: false,
      editForm: {
        oldPassword: '',
        newPassword: '',
        newPassword2: ''
      },
      rules: {
        oldPassword: [
          {
            required: true,
            message: '请输入现密码',
            trigger: 'blur'
          }
        ],
        newPassword: [
          {
            required: true,
            message: '请输入新密码',
            trigger: 'blur'
          },
          {
            pattern: /(?![A-Za-z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,16}$/,
            message: '密码必须为8-16位大小写字母、数字、特殊字符中3种及以上',
            trigger: 'blur'
          },
          {
            validator: validPassword,
            trigger: 'blur'
          }
        ],
        newPassword2: [
          {
            required: true,
            message: '请再次输入新密码',
            trigger: 'blur'
          },
          {
            validator: validPassword2,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    initEditForm () {
      this.$refs.editForm?.resetFields()
    },
    handleSave () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.saveing = true
          const param = {
            oldPassword: this.rsaEncode(this.editForm.oldPassword),
            newPassword: this.rsaEncode(this.editForm.newPassword)
          }
          this.$api.login.resetMyPassword(param, localStorage.getItem('tempToken')).then((res) => {
            this.saveing = false
            if (res.code === 200) {
              this.$message.success('修改成功！')
              VueCookie.set('token', localStorage.getItem('tempToken'))
              localStorage.setItem('token', localStorage.getItem('tempToken'))
              this.$router.replace({
                path: '/manage'
              })
            } else {
              this.$message.error(res.message)
            }
          })
        }
      })
    },
    handleClose () {
      this.$api.login.logout().then(res => {
        localStorage.clear()
        this.$router.push({
          path: '/login'
        })
      })
    },
    rsaEncode (data) {
      const jsRas = new JSEncrypt()
      jsRas.setPublicKey(this.pubKey)
      return jsRas.encrypt(data)
    },
    getPubKey () {
      this.$api.login.getPubKey().then(res => {
        if (res && res.code === 200) {
          this.pubKey = res.data
        }
      })
    }
  },
  mounted () {
    this.initEditForm()
    this.getPubKey()
  }
}
</script>

<style lang="less" scoped>
.reset-password {
  display: flex;
  overflow: auto;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: center;
  flex-wrap: wrap;
  flex-direction: column;
}
.title {
  color: red;
  font-size: 20px;
  margin-left: -70px;
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>
